import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const AmenityLabel = styled.span`
  text-transform: uppercase;
  max-width: ${toRem(100)};
  font-weight: 700;
`;

export const IconWrapper = styled.div`
  color: ${baseVariables.color.bvyBase30};
  font-size: ${toRem(24)};
  margin-bottom: ${toRem(4)};

  > .icon {
    width: ${toRem(24)};
    height: ${toRem(24)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    font-size: ${toRem(36)};
    margin-bottom: ${toRem(12)};

    > .icon {
      width: ${toRem(36)};
      height: ${toRem(36)};

      &:before {
        padding-top: 5px;
      }
    }
  }
`;

export const AmenityItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${toRem(8)};
  padding-bottom: ${toRem(8)};
  cursor: pointer;

  @media ${baseVariables.mediaQuery.xl} {
    padding-top: ${toRem(24)};
    padding-bottom: ${toRem(24)};
  }
`;
